import { Mappable } from '../../_shared/mappable.class';
import { Cue5050 } from './Cue5050';
import { Vendor } from './Vendor';

export class BarrelPrinter extends Mappable<BarrelPrinter>  {
    barrelPrinterId: number;
    name: string;
    vendorId: number;
    vendor: Vendor;
    cue5050Id: number;
    cue5050: Cue5050;
}